'use client'
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/section/DecoratedSection.tsx
import { useEffect, useMemo } from "react";
import { twMerge } from "tailwind-merge";
import { generateThemeFontStyles, generateThemeVars, getFontMimeType } from "@wbk/utils";
import { useRouter } from "@wbk/config";
import { useAnalytics } from "@wbk/analytics";
import { useInView } from "@wbk/hooks";
import { jsx, jsxs } from "react/jsx-runtime";
var DecoratedSection = (_a) => {
  var _b = _a, { section, children, as: Comp = "section" } = _b, props = __objRest(_b, ["section", "children", "as"]);
  var _a2, _b2, _d, _e;
  const hasDecorator = (section == null ? void 0 : section.topDecorator) || (section == null ? void 0 : section.bottomDecorator);
  const bg = section == null ? void 0 : section.sectionBackground;
  const topPadding = (_a2 = section == null ? void 0 : section.topPadding) != null ? _a2 : 48;
  const bottomPadding = (_b2 = section == null ? void 0 : section.bottomPadding) != null ? _b2 : 48;
  const _c = props, { "data-testid": dataTestId } = _c, divProps = __objRest(_c, ["data-testid"]);
  const { pathname } = useRouter();
  const { trackEvent } = useAnalytics();
  const [ref, isVisible] = useInView({ triggerOnce: true });
  useEffect(() => {
    if (isVisible && (section == null ? void 0 : section.id)) {
      trackEvent({
        event: "section_impression",
        data: {
          section: section.id,
          page: pathname
        }
      });
    }
  }, [isVisible, section == null ? void 0 : section.id, pathname, trackEvent]);
  const { fontFaceCss, fontFamily, fontsToPreload } = useMemo(
    () => {
      var _a3, _b3;
      return generateThemeFontStyles({
        font: (_a3 = section.theme) == null ? void 0 : _a3.font,
        bodyFont: (_b3 = section.theme) == null ? void 0 : _b3.bodyFont,
        scope: `section-${section.id}`,
        headingSelector: `#${CSS.escape(section.id)}`
      });
    },
    [(_d = section.theme) == null ? void 0 : _d.font, (_e = section.theme) == null ? void 0 : _e.bodyFont, section.id]
  );
  return /* @__PURE__ */ jsxs(
    Comp,
    __spreadProps(__spreadValues({
      id: section.id,
      className: "relative",
      style: { backgroundColor: section.backgroundColor }
    }, dataTestId ? { "data-testid": dataTestId } : {}), {
      children: [
        fontsToPreload.map((font) => /* @__PURE__ */ jsx(
          "link",
          {
            rel: "preload",
            href: font.url,
            as: "font",
            type: getFontMimeType(font.contentType, font.url),
            crossOrigin: "anonymous"
          },
          font.url
        )),
        fontFaceCss && /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: { __html: fontFaceCss } }),
        bg && /* @__PURE__ */ jsx(
          ContentfulMedia_default,
          {
            media: bg,
            className: "absolute top-0 -z-10 h-full w-full object-cover ltr:left-0 rtl:right-0",
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            disablePictureInPicture: true
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          __spreadProps(__spreadValues({}, divProps), {
            ref,
            className: twMerge("space-y-L text-text", props.className),
            style: __spreadValues(__spreadValues(__spreadValues({
              paddingTop: topPadding,
              paddingBottom: bottomPadding
            }, props.style), section.theme && generateThemeVars(section.theme)), fontFamily && { fontFamily }),
            children: [
              (section == null ? void 0 : section.topDecorator) && /* @__PURE__ */ jsx(
                "div",
                {
                  className: "bg-repeat-x",
                  style: {
                    backgroundImage: `url(${section.topDecorator.url})`,
                    height: section.topDecorator.height
                  }
                }
              ),
              hasDecorator ? /* @__PURE__ */ jsx(
                "div",
                {
                  "data-top-decorator": !!(section == null ? void 0 : section.topDecorator),
                  "data-bottom-decorator": !!(section == null ? void 0 : section.bottomDecorator),
                  className: "data-[bottom-decorator=true]:pb-14 data-[top-decorator=true]:pt-14",
                  children
                }
              ) : children,
              (section == null ? void 0 : section.bottomDecorator) && /* @__PURE__ */ jsx(
                "div",
                {
                  className: "bg-repeat-x",
                  style: {
                    backgroundImage: `url(${section.bottomDecorator.url})`,
                    height: section.bottomDecorator.height
                  }
                }
              )
            ]
          })
        )
      ]
    })
  );
};
var DecoratedSection_default = DecoratedSection;

export {
  DecoratedSection_default
};
//# sourceMappingURL=chunk-HJCFOVNG.mjs.map